module.exports = __webpack_public_path__ + "img/home3.bb384135.jpeg";